const initialState = {
    customFields: null,
	customFieldsForContactForm: null,
	editCustomField: "",
	updateCustomField: "",
    isAddingNewCustomField: false,
	submitCustomField: "",
	editCustomFieldOption: "",
	updateCustomFieldOption: "",
	isAddingNewCustomFieldOption: false,
	submitCustomFieldOption: "",
	customFieldDetails: null,
	customFieldDeletionConfirmationPopup: null,
	customFieldDeletionErrorPopup: null
};

const customFieldsReducer = ( state = initialState, action ) => {
    switch (action.type) {
        case "FETCH_CUSTOM_FIELDS":
            state = {
                ...state,
                customFields: action.payload
            };
            break;
		case "FETCH_CUSTOM_FIELDS_FOR_CONTACT_FORM":
            state = {
                ...state,
				customFieldsForContactForm: action.payload
            };
            break;
	    case "EDIT_CUSTOM_FIELD":
		    state = {
			    ...state,
			    editCustomField: action.payload
		    };
		    break;
	    case "UPDATE_CUSTOM_FIELD":
		    state = {
			    ...state,
			    updateCustomField: action.payload
		    };
		    break;
        case "IS_ADDING_CUSTOM_FIELD":
            state = {
                ...state,
                isAddingNewCustomField: action.payload
            };
            break;
        case "SUBMIT_CUSTOM_FIELD":
            state = {
                ...state,
	            submitCustomField: action.payload
            };
            break;
	    case "EDIT_CUSTOM_FIELD_OPTION":
		    state = {
			    ...state,
			    editCustomFieldOption: action.payload
		    };
		    break;
	    case "UPDATE_CUSTOM_FIELD_OPTION":
		    state = {
			    ...state,
			    updateCustomFieldOption: action.payload
		    };
		    break;
	    case "IS_ADDING_CUSTOM_FIELD_OPTION":
		    state = {
			    ...state,
			    isAddingNewCustomFieldOption: action.payload
		    };
		    break;
	    case "SUBMIT_CUSTOM_FIELD_OPTION":
		    state = {
			    ...state,
			    submitCustomFieldOption: action.payload
		    };
		    break;
	    case "CUSTOM_FIELD_DETAILS":
		    state = {
			    ...state,
			    customFieldDetails: action.payload
		    };
		    break;
	    case "CUSTOM_FIELD_DELETION_CONFIRMATION_POPUP":
		    state = {
			    ...state,
			    customFieldDeletionConfirmationPopup: action.payload
		    };
		    break;
	    case "CUSTOM_FIELD_DELETION_ERROR_POPUP":
		    state = {
			    ...state,
			    customFieldDeletionErrorPopup: action.payload
		    };
		    break;
        default :
            break;
    }
    return state;
};

export default customFieldsReducer;


